export default __webpack_public_path__ + "static/media/mastercard.5982c90a.png";